import { StatisticsTranslate } from './statisticsTranslate.model';

const statisticsTranslateEN: StatisticsTranslate = {
  page: {
    title: 'Statistics',
    subtitle: 'Track your studio financial and operational metrics.',
  },
  tab: {
    exports: 'Exports',
    statistics: 'Statistics',
  },
  planLocked: {
    title: 'Statistics not available on your plan',
    description:
      'The full statistics dashboard is available on higher plans. Upgrade to track your metrics.',
  },
  dateRange: {
    label: 'Period',
    apply: 'Apply',
    clear: 'Clear',
    from: 'From',
    to: 'To',
    presets: {
      thisMonth: 'This month',
      lastMonth: 'Last month',
      lastThreeMonths: 'Last 3 months',
      thisYear: 'This year',
    },
  },
  delta: {
    vsPrevious: 'vs. previous period',
  },
  tabs: {
    label: 'Statistics section',
    overview: 'Overview',
    byMonth: 'By month',
    byClient: 'By client',
    compare: 'Compare periods',
  },
  byMonth: {
    title: 'Sales by month',
    chartTitle: 'Revenue month by month',
    empty: 'No sales in the selected period',
    kpi: {
      totalRevenue: 'Total revenue',
      averageMonthly: 'Monthly average',
      ticketAverage: 'Average ticket',
      bestMonth: 'Best month',
    },
    column: {
      month: 'Month',
      revenue: 'Revenue',
      salesCount: 'Sales',
      ticketAverage: 'Average ticket',
      newClients: 'New',
      returningClients: 'Returning',
    },
  },
  byClient: {
    title: 'Sales by client',
    empty: 'No client with sales in this period',
    recurring: 'Returning',
    searchPlaceholder: 'Search client',
    sortLabel: 'Sort by',
    kpi: {
      totalRevenue: 'Total revenue',
      totalClients: 'Clients',
      recurringClients: 'Returning',
      newClients: 'New',
    },
    column: {
      client: 'Client',
      revenue: 'Revenue',
      salesCount: 'Sales',
      ticketAverage: 'Average ticket',
      lastSaleAt: 'Last purchase',
    },
  },
  compare: {
    title: 'Compare periods',
    subtitle: 'Compare the selected period against another range.',
    currentPeriod: 'Current period',
    currentHint: 'Adjust it in the period picker above.',
    previousPeriod: 'Comparison period',
    reset: 'Use previous period',
    noBaseline: 'No baseline',
    column: {
      metric: 'Metric',
      delta: 'Change',
    },
    metric: {
      totalRevenue: 'Total revenue',
      salesCount: 'Sales',
      ticketAverage: 'Average ticket',
      newClients: 'New clients',
      returningClients: 'Returning clients',
      receivedAmount: 'Received in period',
    },
  },
  receivables: {
    title: 'Collections',
    subtitle: 'Who owes you and what is due soon.',
    overdueTitle: 'Overdue',
    overdueEmpty: 'No overdue installments',
    upcomingTitle: 'Upcoming',
    upcomingEmpty: 'No upcoming installments',
    installmentLabel: 'Installment {{number}}/{{total}}',
    daysOverdue_one: '{{count}} day overdue',
    daysOverdue_other: '{{count}} days overdue',
    kpi: {
      overdueAmount: 'Total overdue',
      overdueClients: 'Clients overdue',
      upcomingAmount: 'Due (30 days)',
    },
  },
  loadError: 'Could not load statistics. Please try again.',
  financial: {
    title: 'Financial',
    kpi: {
      totalRevenue: 'Total revenue',
      ticketAverage: 'Average ticket',
      salesCount: 'Sales count',
      overdueAmount: 'Overdue',
      receivedAmount: 'Received',
      pendingAmount: 'Pending',
    },
    revenueTimeseries: 'Monthly revenue',
    paymentMethodMix: 'Payment method mix',
    topItems: {
      title: 'Top services and packages',
      name: 'Item',
      revenue: 'Revenue',
      count: 'Qty',
      empty: 'No sales in the period.',
    },
    cashForecast: 'Cash forecast',
  },
  funnel: {
    title: 'Funnel',
    kpi: {
      conversionRate: 'Conversion rate',
      newLeads: 'New leads',
      avgSalesCycle: 'Average sales cycle',
    },
    days: 'days',
    eventsByStatus: {
      title: 'Events by status',
      empty: 'No events in the period.',
    },
    contractsByStatus: {
      title: 'Contracts by status',
      empty: 'No contracts in the period.',
      status: {
        DRAFT: 'Draft',
        ISSUED: 'Issued',
        SIGNED: 'Signed',
      },
    },
  },
  operational: {
    title: 'Operational',
    seasonality: 'Seasonality (events per month)',
    kpi: {
      avgBookingLeadTime: 'Average booking lead time',
    },
    days: 'days',
    leadsByBadge: {
      title: 'Leads by badge',
      empty: 'No badges in the period.',
    },
  },
  source: {
    title: 'Sources & losses',
    unknown: 'Not informed',
    unknownReason: 'Other',
    conversionBySource: {
      title: 'Conversion by source',
      empty: 'No leads in the period.',
      ratio: '{{withSale}}/{{total}} ({{rate}}%)',
    },
    lostReasons: {
      title: 'Loss reasons',
      empty: 'No losses in the period.',
    },
  },
};

export default statisticsTranslateEN;
